import { render, staticRenderFns } from "./ThreadReply.vue?vue&type=template&id=511f89ec&scoped=true"
import script from "./ThreadReply.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThreadReply.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ThreadReply.vue?vue&type=style&index=0&id=511f89ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f89ec",
  null
  
)

export default component.exports